@use '@css/variables';



.tileList
{
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 30px;
}

@media only screen and (min-width: variables.$sm-breakpoint) {
  .tileList
  {
    grid-template-columns: repeat(2, 1fr);
  }
}
